var _g, _path, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalarySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 224,
    viewBox: "0 0 230 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4654_38864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.608 4.983a2.83 2.83 0 00-2.781 2.869v148.103a2.829 2.829 0 002.78 2.869h108.107a2.828 2.828 0 002.781-2.869V7.852a2.83 2.83 0 00-2.781-2.87H7.608z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.235 11.834c-1.03 0-1.868.946-1.868 2.109v20.384c0 1.163.838 2.109 1.868 2.109h96.851c1.031 0 1.869-.946 1.869-2.109V13.943c0-1.163-.838-2.11-1.869-2.11h-96.85zm0 34.49a1.898 1.898 0 00-1.868 1.922v43.569a1.898 1.898 0 001.868 1.922h96.852a1.897 1.897 0 001.868-1.922v-43.57a1.897 1.897 0 00-1.868-1.921H13.235z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.965 14.714H23.356v4.36h76.61v-4.36zm.156 9.187H23.512v2.025h76.609V23.9zm0 3.582H23.512v2.024h76.609v-2.024zm0 3.581H23.512v2.024h76.609v-2.024zM68.874 93.815h35.256a1.136 1.136 0 00.803-1.938L82.368 69.314a1.136 1.136 0 00-1.605 0l-5.61 5.611a2.379 2.379 0 01-3.367 0L54.21 57.35a1.137 1.137 0 00-1.605 0L18.233 91.722a1.135 1.135 0 00.803 1.937h49.883l-.045.156z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.235 103.936a1.897 1.897 0 00-1.868 1.922v43.569a1.9 1.9 0 001.868 1.922h96.852a1.894 1.894 0 001.868-1.922v-43.569a1.896 1.896 0 00-1.868-1.922H13.235z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.874 151.427h35.256a1.133 1.133 0 00.803-1.937l-22.565-22.564a1.135 1.135 0 00-1.605 0l-5.61 5.611a2.386 2.386 0 01-1.684.697 2.373 2.373 0 01-1.683-.697L54.21 114.962a1.139 1.139 0 00-1.605 0l-34.373 34.372a1.136 1.136 0 00.803 1.938h49.883l-.045.155z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4654_38864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.937 40.173a2.83 2.83 0 00-2.781 2.869v148.103a2.83 2.83 0 002.78 2.869h108.107a2.828 2.828 0 002.781-2.869V43.042a2.833 2.833 0 00-2.781-2.869H47.937z",
    fill: "#fff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.767 61.66c-.247.001-.483.136-.657.375a1.55 1.55 0 00-.273.902v5.856c0 .338.099.663.273.902.174.24.41.374.657.374h54.819c.247 0 .483-.135.657-.374.174-.24.272-.563.273-.902v-5.856a1.558 1.558 0 00-.273-.902c-.174-.24-.41-.374-.657-.374h-54.82z",
    fill: "var(--color-secondary-light)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.386 80.638a.312.312 0 00-.311.312v2.232a.312.312 0 00.31.311h74.741a.31.31 0 00.22-.091.31.31 0 00.092-.22V80.95a.31.31 0 00-.092-.22.31.31 0 00-.22-.092h-74.74zm0 7.255a.312.312 0 00-.311.311v2.232a.311.311 0 00.31.312h74.741a.31.31 0 00.22-.092.31.31 0 00.092-.22v-2.232a.31.31 0 00-.092-.22.31.31 0 00-.22-.091h-74.74zm0 7.254a.312.312 0 00-.311.312v2.232a.312.312 0 00.31.311h74.741a.31.31 0 00.22-.091.31.31 0 00.092-.22v-2.232a.31.31 0 00-.092-.22.31.31 0 00-.22-.092h-74.74zm-.156 14.491a.31.31 0 00-.311.312v2.232a.313.313 0 00.311.311h74.741a.315.315 0 00.22-.091.315.315 0 00.091-.22v-2.232a.311.311 0 00-.311-.312h-74.74zm0 7.255a.313.313 0 00-.311.311v2.232a.31.31 0 00.311.311h74.741a.31.31 0 00.311-.311v-2.232a.315.315 0 00-.091-.22.315.315 0 00-.22-.091h-74.74zm0 7.254a.313.313 0 00-.311.312v2.232a.314.314 0 00.311.311h74.741a.315.315 0 00.22-.091.315.315 0 00.091-.22v-2.232a.315.315 0 00-.091-.221.315.315 0 00-.22-.091h-74.74zm0 7.291a.309.309 0 00-.311.311v2.232a.312.312 0 00.311.311h74.741a.313.313 0 00.311-.311v-2.232a.311.311 0 00-.311-.311h-74.74zm0 7.254a.313.313 0 00-.311.311v2.232a.313.313 0 00.311.312h74.741a.315.315 0 00.22-.091.315.315 0 00.091-.221v-2.232a.315.315 0 00-.091-.22.315.315 0 00-.22-.091h-74.74zm0 7.254a.314.314 0 00-.311.312v2.232a.312.312 0 00.311.311h74.741a.313.313 0 00.311-.311v-2.232a.311.311 0 00-.311-.312h-74.74zm0 7.291a.313.313 0 00-.311.311v2.232a.31.31 0 00.091.22.31.31 0 00.22.092h74.741a.311.311 0 00.311-.312v-2.232a.313.313 0 00-.311-.311h-74.74zm0 7.254a.31.31 0 00-.22.092.31.31 0 00-.091.22v2.232a.314.314 0 00.311.311h74.741a.315.315 0 00.22-.091.315.315 0 00.091-.22v-2.232a.311.311 0 00-.311-.312h-74.74zm0 7.255a.313.313 0 00-.311.311v2.232a.314.314 0 00.311.312h74.741a.311.311 0 00.311-.312v-2.232a.313.313 0 00-.311-.311h-74.74z",
    fill: "#DADADA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.734 71.385c-2.682 0-4.997-2.438-4.997-5.485s2.193-5.485 4.997-5.485c1.828 0 3.534 1.097 4.388 3.047.121.366 0 .61-.244.853-.366.122-.61 0-.853-.243-.61-1.463-1.95-2.316-3.291-2.316-2.072 0-3.779 1.828-3.779 4.266 0 2.437 1.707 4.266 3.779 4.266 1.34 0 2.681-.853 3.29-2.316.122-.366.488-.488.854-.244.365.122.487.488.243.853-.853 1.707-2.56 2.804-4.387 2.804z",
    fill: "var(--color-secondary)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.37 65.046h-5.607c-.365 0-.609-.244-.609-.61 0-.365.244-.609.61-.609h5.606c.366 0 .61.244.61.61 0 .365-.244.609-.61.609zm-.002 3.291h-5.606c-.366 0-.61-.243-.61-.61 0-.365.244-.609.61-.609h5.606c.366 0 .61.244.61.61s-.244.61-.61.61z",
    fill: "var(--color-secondary)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.338 63c-2.175 0-4.053-2-4.053-4.5s1.78-4.5 4.053-4.5c1.483 0 2.867.9 3.56 2.5.098.3 0 .5-.199.7-.296.1-.494 0-.692-.2-.494-1.2-1.581-1.9-2.669-1.9-1.68 0-3.064 1.5-3.064 3.5s1.384 3.5 3.064 3.5c1.088 0 2.175-.7 2.67-1.9.098-.3.395-.4.691-.2.297.1.396.4.198.7-.692 1.4-2.076 2.3-3.559 2.3z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.043 57.8h-4.548c-.297 0-.494-.2-.494-.5s.197-.5.494-.5h4.547c.297 0 .495.2.495.5s-.198.5-.494.5zm-.001 2.7h-4.548c-.296 0-.494-.2-.494-.5s.198-.5.494-.5h4.548c.296 0 .494.2.494.5s-.198.5-.494.5zm.296 60.347c-2.175 0-4.053-2-4.053-4.5s1.78-4.5 4.053-4.5c1.483 0 2.867.9 3.56 2.5.098.3 0 .5-.198.7-.297.1-.495 0-.692-.2-.495-1.2-1.582-1.9-2.67-1.9-1.68 0-3.064 1.5-3.064 3.5s1.384 3.5 3.064 3.5c1.088 0 2.175-.7 2.67-1.9.098-.3.395-.4.692-.2.296.1.395.4.197.7-.692 1.4-2.076 2.3-3.559 2.3z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.043 115.646h-4.548c-.296 0-.494-.2-.494-.5s.198-.5.494-.5h4.548c.296 0 .494.2.494.5s-.198.5-.494.5zm-.001 2.701h-4.548c-.296 0-.494-.2-.494-.5s.198-.5.494-.5h4.548c.296 0 .494.2.494.5s-.198.5-.494.5z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M204.758 154.486l-39.832 39.513a2.649 2.649 0 01-3.746-.015l-18.953-19.107a2.648 2.648 0 01.015-3.745l1.88-1.865a2.648 2.648 0 013.745.015l15.224 15.346 36.072-35.783a2.648 2.648 0 013.745.015l1.865 1.881a2.648 2.648 0 01-.015 3.745z",
    fill: "#49BC74"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4654_38864",
    x: 2.827,
    y: 3.983,
    width: 117.668,
    height: 157.841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4654_38864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4654_38864",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4654_38864",
    x: 43.156,
    y: 39.173,
    width: 117.668,
    height: 157.841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4654_38864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4654_38864",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalarySuccess);
export default __webpack_public_path__ + "static/media/salarySuccess.37694e05d4e0771ffe1355a84b6eb177.svg";
export { ForwardRef as ReactComponent };